@use './variables' as *;
@use '../../styles/abstracts/icons' as *;

@mixin iconClass($name, $value) {
  .icon-#{$name} {
    -webkit-mask: $value no-repeat 100% 100%;
    mask: $value no-repeat 100% 100%;
  }
}

:host {
  display: $icon-host-display;
}

.icon {
  display: $icon-display;
  padding: $icon-padding;
  margin: $icon-margin;
  border: $icon-border;
  border-radius: $icon-border-radius;
  box-shadow: $icon-box-shadow;
  height: $icon-size;
  width: $icon-size;
  -webkit-mask: $icon no-repeat 100% 100%;
  -webkit-mask-size: cover;
  mask: $icon no-repeat 100% 100%;
  mask-size: cover;
  background-color: currentColor;
}

@include iconClass('alert-circle', $icon-alert-circle);
@include iconClass('alert-triangle', $icon-alert-triangle);
@include iconClass('calendar', $icon-calendar);
@include iconClass('check-circle', $icon-check-circle);
@include iconClass('chevron-down', $icon-chevron-down);
@include iconClass('chevron-left', $icon-chevron-left);
@include iconClass('chevron-right', $icon-chevron-right);
@include iconClass('chevron-up', $icon-chevron-up);
@include iconClass('eye', $icon-eye);
@include iconClass('eye-off', $icon-eye-off);
@include iconClass('info', $icon-info);
@include iconClass('search', $icon-search);
@include iconClass('slash', $icon-slash);
@include iconClass('x', $icon-x);
